import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';

const styles = {
  compact: {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      maxWidth: 132,
      px: 1,
      py: 0.65,
      borderRadius: 2,
      background: 'linear-gradient(135deg, rgba(212,165,116,0.18) 0%, rgba(184,137,74,0.1) 100%)',
      border: '1px solid',
      borderColor: alpha('#B8894A', 0.28),
      boxShadow: '0 2px 8px rgba(184,137,74,0.1)',
    },
    text: {
      fontWeight: 800,
      fontSize: { xs: '0.68rem', sm: '0.72rem' },
      lineHeight: 1.3,
      color: 'primary.main',
      letterSpacing: 0.1,
    },
  },
  row: {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      maxWidth: 220,
      px: 1.25,
      py: 0.85,
      borderRadius: 2.5,
      background: 'linear-gradient(135deg, rgba(212,165,116,0.2) 0%, rgba(184,137,74,0.1) 100%)',
      border: '1px solid',
      borderColor: alpha('#B8894A', 0.3),
      boxShadow: '0 4px 12px rgba(184,137,74,0.12)',
    },
    text: {
      fontWeight: 800,
      fontSize: '0.88rem',
      lineHeight: 1.35,
      color: 'primary.main',
    },
  },
  detail: {
    root: {
      display: 'flex',
      alignItems: 'center',
      p: 2,
      borderRadius: 3,
      background:
        'linear-gradient(135deg, rgba(212,165,116,0.16) 0%, rgba(184,137,74,0.08) 55%, rgba(143,106,53,0.06) 100%)',
      border: '1px solid',
      borderColor: alpha('#B8894A', 0.22),
      boxShadow: '0 6px 18px rgba(184,137,74,0.1)',
    },
    text: {
      fontWeight: 800,
      fontSize: { xs: '1.05rem', md: '1.2rem' },
      lineHeight: 1.4,
      color: 'primary.main',
      letterSpacing: 0.15,
    },
  },
};

export default function PriceAskLabel({ label, variant = 'compact' }) {
  const sx = styles[variant] ?? styles.compact;

  return (
    <Box sx={sx.root}>
      <Typography component="span" sx={sx.text}>
        {label}
      </Typography>
    </Box>
  );
}
